import AccessRequestTrack from "../Track";

const AccessRequestActivate = AccessRequestTrack;

export default AccessRequestActivate;
